// extracted by mini-css-extract-plugin
export default {"main":"BackButton_main__AV7rl","btnWrapper":"BackButton_btnWrapper__KPnJI"};